import Theme from "../../../../components/AssetManagement/Design/Theme/Theme";
import Page404 from "../../../../components/Page404/Page403";
import { CheckPermissionsDesign } from "../CheckPermission/CheckDesignPermissions";

function ThemeScreen({ response }: { userToken: any; response: any }) {
  const hasViewThemePermission = CheckPermissionsDesign(
    response?.products,
    "view_theme"
  );

  return <div>{hasViewThemePermission ? <Theme /> : <Page404 />}</div>;
}

export default ThemeScreen;
